<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="computedHeaders"
          :items="indexedItems"
          :item-class="getRowColor"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
          @item-expanded="onItemExpanded"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>

          <template v-slot:header.proxima_consulta="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Recomendação de data máxima para realizar a próxima consulta com base no protocolo de pré-natal e idade gestacional atual da gestante."
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:header.total_bp="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Data do último atendimento e percentual da(s) boa(s) prática(s) aplicável(is) realizada(s)."
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:header.denominador="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Puérperas que serão consideradas na avaliação do quadrimestre atual"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            {{
              item.dt_nascimento != null ? formatDate(item.dt_nascimento) : ''
            }}
            <br />
            ({{ item.idade }} {{ item.idade > 1 ? 'anos' : 'ano' }})
          </template>

          <template v-slot:item.proxima_consulta="{ item }">
            {{
              item.proxima_consulta != null
                ? formatDate(item.proxima_consulta)
                : ''
            }}
          </template>

          <template v-slot:item.total_bp="{ item }">
            {{ item.ult_atend != null ? formatDate(item.ult_atend) : '' }}
            <br />
            <span>({{ item.total_bp ?? 0 }}%)</span>
          </template>

          <template v-slot:item.parto="{ item }">
            {{ item.parto ? formatDate(item.parto) : '' }}
          </template>

          <template v-slot:item.denominador="{ item }">
            {{ item.den_puerpera == 1 ? 'Sim' : '' }}
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="9">
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                    <th>
                      Trimestre
                      <span
                        v-b-tooltip.hover.right
                        title="Trimestre atual da gestação"
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      IG
                      <span
                        v-b-tooltip.hover.right
                        title="Idade Gestacional Atual"
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>Auto referido</th>
                    <th>Microárea</th>
                    <th>Cadastrado por</th>
                    <th v-if="exibirCopilot">Suporte</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.nu_cpf }}</td>
                    <td>{{ item.nu_cns }}</td>
                    <td>{{ item.trimestre }}</td>
                    <td>{{ item.ig_atual }}</td>
                    <td>{{ item.st_gestante == 1 ? 'Sim' : 'Não' }}</td>
                    <td>{{ item.micro_area }}</td>
                    <td>{{ item.no_profissional }}</td>
                    <td v-if="exibirCopilot">
                      <copilot :item="item" :rules="item.rules"></copilot>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table class="table table-interna table-boas-praticas">
                <thead>
                  <tr>
                    <th>
                      Primeira consulta
                      <span
                        v-b-tooltip.hover.right
                        title="(A) Ter a 1ª consulta presencial ou remota realizada por médica(o) ou enfermeira(o), até a 12ª semana de gestação."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Consultas
                      <span
                        v-b-tooltip.hover.right
                        title="(B) Ter pelo menos 07 (sete) consultas presenciais ou remotas realizadas por médica(o) ou
enfermeira(o) durante o período da gestação."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Aferição PA
                      <span
                        v-b-tooltip.hover.right
                        title="(C) Ter pelo menos 07 (sete) registro de aferição de pressão arterial realizados durante o
período da gestação."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Peso e altura
                      <span
                        v-b-tooltip.hover.right
                        title="(D) Ter pelo menos 07 (sete) registros simultâneos de peso e altura durante o período da
gestação."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Visitas gestante
                      <span
                        v-b-tooltip.hover.right
                        title="(E) Ter pelo menos 03 (três) visitas domiciliares realizadas por ACS/TACS, após a primeira
consulta do pré-natal."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Vacinas
                      <span
                        v-b-tooltip.hover.right
                        title="(F) Ter vacina acelular contra difteria, tétano, coqueluche (dTpa) registrada a partir da 20ª
semana de cada gestação."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.a_pb == null || item.a_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('primeira-consulta', item)"
                      >
                        {{ item.a_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.b_pb == null || item.b_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('consultas', item)"
                      >
                        {{
                          getTextButtonBoaPratica(
                            item.b_pb,
                            item.dpp,
                            item.parto,
                            'consultas'
                          )
                        }}
                      </div>
                    </td>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.c_pb == null || item.c_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('afericao-pa', item)"
                      >
                        {{
                          getTextButtonBoaPratica(
                            item.c_pb,
                            item.dpp,
                            item.parto,
                            'afericao-pa'
                          )
                        }}
                      </div>
                    </td>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.d_pb == null || item.d_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('peso-altura', item)"
                      >
                        {{
                          getTextButtonBoaPratica(
                            item.d_pb,
                            item.dpp,
                            item.parto,
                            'peso-altura'
                          )
                        }}
                      </div>
                    </td>
                    <td v-if="item.tp_ine_fci != '76'">
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.e_pb == null || item.e_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('visitas', item)"
                      >
                        {{
                          getTextButtonBoaPratica(
                            item.e_pb,
                            item.dpp,
                            item.parto
                          )
                        }}
                      </div>
                    </td>
                    <td v-else>Não se aplica</td>
                    <td v-if="item.ig_atual >= 20">
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.f_pb == null || item.f_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('vacinas', item)"
                      >
                        {{ item.f_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                    <td v-else>Não se aplica</td>
                  </tr>
                </tbody>
              </table>

              <table class="table table-interna table-boas-praticas">
                <thead>
                  <tr>
                    <th>
                      Exames 1° trimestre
                      <span
                        v-b-tooltip.hover.right
                        title="(G) Ter registro dos testes rápidos ou dos exames avaliados para sífilis, HIV e hepatites B e C
realizados no 1º trimestre de cada gestação."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Exames 3° trimestre
                      <span
                        v-b-tooltip.hover.right
                        title="(H) Ter registro dos testes rápidos ou dos exames avaliados para sífilis e HIV realizados no 3º
trimestre de cada gestação."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Consulta puerperal
                      <span
                        v-b-tooltip.hover.right
                        title="(I) Ter pelo menos 01 (um) registro de consulta presencial ou remota realizada por médica(o) ou
enfermeira(o) durante o puerpério."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Visita puerpério
                      <span
                        v-b-tooltip.hover.right
                        title="(J) Ter pelo menos 01 (uma) visita domiciliar realizada por ACS/TACS durante o puerpério."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Avaliação odontológica
                      <span
                        v-b-tooltip.hover.right
                        title="(K) Ter pelo menos 01 (uma) atividade em saúde bucal realizada por cirurgiã(ão) dentista ou
técnica(o) de saúde bucal durante o período da gestação."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Problemas
                      <span
                        v-b-tooltip.hover.right
                        title="Lista de problemas ou condições ativos e resolvidos."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.g_pb == null || item.g_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('primeiro-trimestre', item)"
                      >
                        {{ item.g_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                    <td v-if="item.trimestre >= 3">
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.h_pb == null || item.h_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('terceiro-trimestre', item)"
                      >
                        {{ item.h_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                    <td v-else>Não se aplica</td>
                    <td v-if="item.ainda_gestante == 0">
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.i_pb == null || item.i_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('consulta-puerperio', item)"
                      >
                        {{ item.i_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                    <td v-else>Não se aplica</td>
                    <td
                      v-if="item.ainda_gestante == 0 && item.tp_ine_fci != '76'"
                    >
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.j_pb == null || item.j_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('visita-puerperio', item)"
                      >
                        {{ item.j_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                    <td v-else>Não se aplica</td>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.k_pb == null || item.k_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('avaliacao-odontologica', item)"
                      >
                        {{ item.k_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                    <td v-if="item.probl_evolucao != null">
                      <div
                        class="table-boas-praticas-item green"
                        @click="openModal('problema', item)"
                      >
                        {{
                          item.probl_ativo != 2
                            ? 'Ativo'
                            : item.probl_ativo == 2
                            ? 'Resolvido'
                            : ''
                        }}
                      </div>
                    </td>
                    <td v-else>Não se aplica</td>
                  </tr>
                </tbody>
              </table>

              <b-alert
                v-if="item.a_pb == null || item.a_pb == 0"
                variant="danger"
                show
                >Mulher sem ter realizado a primeira consulta de pré-natal até
                12 semanas de gestação.</b-alert
              >

              <b-alert
                v-if="item.b_pb == null || item.b_pb == 0"
                variant="danger"
                show
              >
                Mulher deveria ter realizado pelo menos
                {{ item.qtd_atends_pa_pes_alts }} consulta(s) de pré-natal até o
                momento.
              </b-alert>

              <b-alert
                v-if="item.c_pb == null || item.c_pb == 0"
                variant="danger"
                show
              >
                Mulher deveria ter realizado pelo menos
                {{ item.qtd_atends_pa_pes_alts }} registro(s) de aferição de PA
                até o momento.
              </b-alert>

              <b-alert
                v-if="item.d_pb == null || item.d_pb == 0"
                variant="danger"
                show
                >Mulher deveria ter realizado pelo menos
                {{ item.qtd_atends_pa_pes_alts }} registro(s) de peso e altura
                até o momento.
              </b-alert>

              <b-alert
                v-if="item.e_pb == null || item.e_pb == 0"
                variant="danger"
                show
                >Mulher deveria ter recebido pelo menos
                {{ item.qtd_visitas }} visita(s) domiciliares do ACS/Tacs até o
                momento.
              </b-alert>

              <b-alert
                v-if="
                  item.ig_atual >= 20 && (item.f_pb == null || item.f_pb == 0)
                "
                variant="danger"
                show
                >Mulher deveria ter registro de uma dose de dTpa a partir da 20ª
                semana de cada gestação.
              </b-alert>

              <b-alert
                v-if="item.g_pb == null || item.g_pb == 0"
                variant="danger"
                show
                >Mulher deveria ter registro dos testes rápidos ou dos exames
                avaliados para sífilis, HIV e hepatites B e C realizados no
                primeiro trimestre de cada gestação.
              </b-alert>

              <b-alert
                v-if="
                  item.trimestre >= 3 && (item.h_pb == null || item.h_pb == 0)
                "
                variant="danger"
                show
                >Mulher deveria ter registro dos testes rápidos ou dos exames
                avaliados para sífilis e HIV realizados no terceiro trimestre de
                cada gestação.
              </b-alert>

              <b-alert
                v-if="
                  item.ainda_gestante == 0 &&
                  (item.i_pb == null || item.i_pb == 0)
                "
                variant="danger"
                show
                >Mulher deveria ter registro de pelo menos 01 consulta
                presencial ou remota por profissional médica(o) ou enfermeira(o)
                realizada durante o puerpério.
              </b-alert>

              <b-alert
                v-if="
                  item.ainda_gestante == 0 &&
                  item.tp_ine_fci != '76' &&
                  (item.j_pb == null || item.j_pb == 0)
                "
                variant="danger"
                show
                >Mulher deveria ter registro de pelo menos 01 visita domiciliar
                por ACS/Tacs realizada durante o puerpério.
              </b-alert>

              <b-alert
                v-if="item.k_pb == null || item.k_pb == 0"
                variant="danger"
                show
                >Mulher deveria ter registro de pelo menos 01 avaliação
                odontológica realizada durante o período da gestação por
                profissional cirurgiã(ão) dentista.
              </b-alert>
            </td>
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <b-modal
        id="modal-gestantes-puerperas"
        ref="modal"
        title=""
        v-model="modal.show"
        centered
        scrollable
        hide-footer
        size="xl"
      >
        <template #modal-title> {{ modal.title }}</template>
        <div class="modal-gestantes-puerperas-body" v-if="modal.item != null">
          <!-- Filtro Consultas -->
          <div
            v-if="modal.tipo === 'consultas' && modal.filter.consultas.enabled"
            class="mb-3 d-flex align-items-center justify-content-between gap-2"
          >
            <b-form-select
              v-model="modal.filter.consultas.selected"
              :options="modal.filter.consultas.options"
              class="w-auto"
            />

            <button class="btn" @click="showAjudaModalCidCiapsConsultas = true">
              <i class="icofont-question"></i>
            </button>

            <modal-ajuda-cids-ciaps
              :show.sync="showAjudaModalCidCiapsConsultas"
              :grupo-filtro="[]"
            />
          </div>

          <!-- Consulta puerperal -->
          <div
            v-if="modal.tipo === 'consulta-puerperio'"
            class="mb-3 d-flex align-items-center justify-content-end"
          >
            <button
              class="btn"
              @click="showAjudaModalCidCiapsConsultaPuerperal = true"
            >
              <i class="icofont-question"></i>
            </button>

            <modal-ajuda-cids-ciaps
              :show.sync="showAjudaModalCidCiapsConsultaPuerperal"
              :grupo-filtro="['PARTO', 'ABORTO']"
            />
          </div>

          <!-- Problemas -->
          <div
            v-if="modal.tipo === 'problema'"
            class="mb-3 d-flex align-items-center justify-content-end"
          >
            <button
              class="btn"
              @click="showAjudaModalCidCiapsConsultaProblemas = true"
            >
              <i class="icofont-question"></i>
            </button>

            <modal-ajuda-cids-ciaps
              :show.sync="showAjudaModalCidCiapsConsultaProblemas"
              :grupo-filtro="[]"
            />
          </div>

          <!-- Primeira consulta -->
          <div v-if="modal.tipo == 'primeira-consulta'">
            <primeira-consulta :modal="modal"></primeira-consulta>
          </div>
          <div v-else>
            <table
              class="table table-interna"
              v-if="modal.table.headers.length > 0"
            >
              <thead>
                <tr>
                  <th
                    v-for="(itemHeader, indexHeader) in modal.table.headers"
                    :key="indexHeader"
                  >
                    {{ itemHeader.label }}
                    <span
                      v-if="itemHeader.icon.show == true"
                      v-b-tooltip.hover.top
                      :title="itemHeader.icon.text"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </th>
                </tr>
              </thead>

              <!-- Consultas -->
              <tbody v-if="modal.tipo == 'consultas'">
                <tr
                  v-for="(item, index) in getConsultasFiltradas(modal.item.fai)"
                  :key="index"
                  :class="item.cons_pn == 1 ? 'green' : ''"
                >
                  <td>
                    {{
                      item.cons_pn == 1 && item.parto != 1 && item.aborto != 1
                        ? getConsultaIndexLista(
                            getConsultasFiltradas(modal.item.fai),
                            index
                          )
                        : ''
                    }}
                  </td>
                  <td>{{ formatDate(item.dt_atendimento) ?? '' }}</td>
                  <td>{{ item.tp_atend }}</td>
                  <td>
                    {{ item.nu_cbo ?? '' }}
                    <span
                      v-b-tooltip.hover.top
                      :title="item.no_cbo"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </td>
                  <td>
                    {{ item.cnes ?? '' }}
                    <span
                      v-b-tooltip.hover.top
                      :title="item.ubs"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </td>
                  <td>
                    {{ item.motivo }}
                  </td>
                </tr>
              </tbody>
              <!-- Aferição PA -->
              <tbody v-if="modal.tipo == 'afericao-pa'">
                <tr
                  v-for="(item, index) in JSON.parse(modal.item.afericao_pa)"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ formatDate(item.dt_procedimento) ?? '' }}</td>
                  <td>
                    {{ item.sistolica ?? '' }}
                  </td>
                  <td>
                    {{ item.diastolica ?? '' }}
                  </td>
                  <td>
                    {{ item.nu_cbo ?? '' }}
                    <span
                      v-if="item.nu_cbo != null"
                      v-b-tooltip.hover.top
                      :title="item.no_cbo"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </td>
                  <td>
                    {{ item.mi ?? '' }}
                  </td>
                </tr>
              </tbody>
              <!-- Peso e altura -->
              <tbody v-if="modal.tipo == 'peso-altura'">
                <tr
                  v-for="(item, index) in JSON.parse(modal.item.peso_altura)"
                  :key="index"
                >
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td>{{ formatDate(item.dt_procedimento) ?? '' }}</td>
                  <td>
                    {{ item.peso ?? '' }}
                  </td>
                  <td>
                    {{ item.altura ?? '' }}
                  </td>
                  <td>
                    {{ item.nu_cbo ?? '' }}
                    <span
                      v-if="item.nu_cbo != null"
                      v-b-tooltip.hover.top
                      :title="item.no_cbo"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </td>
                  <td>
                    {{ item.mi ?? '' }}
                  </td>
                </tr>
              </tbody>
              <!-- Visitas -->
              <tbody v-if="modal.tipo == 'visitas'">
                <tr
                  v-for="(item, index) in JSON.parse(modal.item.fvdt)"
                  :key="index"
                  :class="item.motivo_acomp == 'Gestante' ? 'green' : ''"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ formatDate(item.dt_visita) ?? '' }}</td>
                  <td>
                    {{ item.motivo_acomp }}
                  </td>
                  <td>
                    {{ item.desfecho ?? '' }}
                  </td>
                </tr>
              </tbody>
              <!-- Primeiro trimestre -->
              <tbody v-if="modal.tipo == 'primeiro-trimestre'">
                <tr
                  v-for="(item, index) in JSON.parse(
                    modal.item.exames_sol_aval
                  )"
                  :key="index"
                  :class="item.trimestre == 1 ? 'green' : ''"
                >
                  <td>{{ formatDate(item.dt_procedimento) ?? '' }}</td>
                  <td>
                    {{ item.ds_proced ?? '' }}
                    <span
                      v-b-tooltip.hover.top
                      :title="item.co_proced"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </td>
                  <td>
                    {{ item.tipo ?? '' }}
                  </td>
                  <td>
                    {{ item.trimestre ?? '' }}
                  </td>
                </tr>
              </tbody>
              <!-- Terceiro trimestre -->
              <tbody v-if="modal.tipo == 'terceiro-trimestre'">
                <tr
                  v-for="(item, index) in JSON.parse(
                    modal.item.exames_sol_aval
                  )"
                  :key="index"
                  :class="item.trimestre == 3 ? 'green' : ''"
                >
                  <td>{{ formatDate(item.dt_procedimento) ?? '' }}</td>
                  <td>
                    {{ item.ds_proced ?? '' }}
                    <span
                      v-b-tooltip.hover.top
                      :title="item.co_proced"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </td>
                  <td>
                    {{ item.tipo ?? '' }}
                  </td>
                  <td>
                    {{ item.trimestre ?? '' }}
                  </td>
                </tr>
              </tbody>
              <!-- Consulta puerperal -->
              <tbody v-if="modal.tipo == 'consulta-puerperio'">
                <tr
                  v-for="(item, index) in getDadosConsultaPerperio(
                    modal.item,
                    modal.item.fai
                  )"
                  :key="index"
                >
                  <td>{{ formatDate(item.dt_atendimento) ?? '' }}</td>
                  <td>
                    {{ item.nu_cbo ?? '' }}
                    <span
                      v-b-tooltip.hover.top
                      :title="item.no_cbo"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </td>
                  <td>
                    {{ getTextConsultas(item) }}
                  </td>
                </tr>
              </tbody>
              <!-- Visita puerpério -->
              <tbody v-if="modal.tipo == 'visita-puerperio'">
                <tr
                  v-for="(item, index) in getVisitasPuerperio(
                    modal.item.fvdt,
                    modal.item.parto,
                    modal.item.dpp
                  )"
                  :key="index"
                >
                  <td>{{ formatDate(item.dt_visita) ?? '' }}</td>
                  <td>
                    {{ item.motivo_acomp }}
                  </td>
                  <td>
                    {{ item.desfecho ?? '' }}
                  </td>
                </tr>
              </tbody>
              <!-- Avaliação odontológica -->
              <tbody v-if="modal.tipo == 'avaliacao-odontologica'">
                <tr
                  v-for="(item, index) in JSON.parse(modal.item.fao)"
                  :key="index"
                >
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td>{{ formatDate(item.dt_atendimento) ?? '' }}</td>
                  <td>
                    {{ item.nu_cbo ?? '' }}
                    <span
                      v-b-tooltip.hover.top
                      :title="item.no_cbo"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </td>
                </tr>
              </tbody>
              <!-- Problemas -->
              <tbody v-if="modal.tipo == 'problema'">
                <tr
                  v-for="(item, index) in JSON.parse(modal.item.probl_evolucao)"
                  :key="index"
                >
                  <td>
                    {{ item.nu_uuid_problema }}
                  </td>
                  <td>
                    {{ item.id_grupo }}
                  </td>
                  <td>{{ formatDate(item.dt_inicio) ?? '' }}</td>
                  <td>{{ formatDate(item.dt_fim) ?? '' }}</td>
                  <td>
                    {{ item.ds_situacao_problema ?? '' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Vacinas -->
          <div v-if="modal.tipo == 'vacinas'">
            <div class="doses-list">
              <h4>dTpa</h4>
              <div
                class="doses-list-item"
                :class="modal.item.vacina == null ? 'red' : 'green'"
                @click="openModalVacina(modal.item)"
              >
                <strong>DOSE</strong>
                <span v-if="modal.item.vacina != null">
                  {{
                    formatDate(JSON.parse(modal.item.vacina)[0].dt_aplicacao)
                  }}
                </span>
              </div>
            </div>
            <b-modal
              id="modal2"
              title="dTpa"
              v-model="modalVacinas.show"
              :modal-class="'modal-zindex-top'"
              centered
              scrollable
              hide-footer
            >
              <ValidationObserver ref="observerModalVacinas" class="row">
                <div class="col-lg-6">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <div class="mb-2">
                      <the-mask
                        :mask="['##/##/####']"
                        v-model="modalVacinas.form.dataAplicacao"
                        required
                        class="form-control"
                        placeholder="Data da aplicação"
                        :disabled="
                          modalVacinas.form.btn.loading ||
                          !modalVacinas.form.podeEditar
                        "
                      />
                    </div>
                    <div class="error">{{ errors[0] }}</div>
                  </validation-provider>
                </div>
                <div class="col-lg-6">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <div class="mb-2">
                      <input
                        name="lote"
                        v-model="modalVacinas.form.lote"
                        class="form-control"
                        placeholder="Lote"
                        type="text"
                        required
                        :disabled="
                          modalVacinas.form.btn.loading ||
                          !modalVacinas.form.podeEditar
                        "
                      />
                    </div>
                    <div class="error">{{ errors[0] }}</div>
                  </validation-provider>
                </div>
                <div class="col-lg-12">
                  <button
                    type="submit"
                    class="btn mt-2"
                    :disabled="
                      modalVacinas.form.btn.loading ||
                      !modalVacinas.form.podeEditar
                    "
                    v-on:click="salvarVacina(modal.item)"
                  >
                    {{
                      modalVacinas.form.mode === 'edit' ? 'Atualizar' : 'Salvar'
                    }}
                    <b-spinner
                      small
                      label="Small Spinner"
                      variant="white"
                      v-if="modalVacinas.form.btn.loading"
                    ></b-spinner>
                  </button>
                </div>
              </ValidationObserver>
            </b-modal>
          </div>
        </div>
      </b-modal>
    </div>
  </v-app>
</template>

<script>
import Vue from 'vue'
import * as Functions from '../functions.js'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import Copilot from '@/components/Copilot.vue'
import { rulesCopilot } from '../copilot.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import { TheMask } from 'vue-the-mask'
import PrimeiraConsulta from './PrimeiraConsulta.vue'
import ModalAjudaCidsCiaps from './ModalAjudaCidsCiaps.vue'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
    Copilot,
    ValidationObserver,
    ValidationProvider,
    TheMask,
    PrimeiraConsulta,
    ModalAjudaCidsCiaps,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tipo: {
      type: String,
      default: 'gestantes',
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      modal: {
        title: '',
        tipo: null,
        show: false,
        item: null,
        table: {
          headers: [],
        },
        filter: {
          consultas: {
            enabled: true,
            options: [
              { value: 'todas', text: 'Todas as consultas' },
              { value: 'somente-aps', text: 'Somente APS' },
            ],
            selected: 'todas',
          },
        },
      },
      modalVacinas: {
        show: false,
        form: {
          dataAplicacao: null,
          lote: null,
          btn: {
            disabled: false,
            loading: false,
          },
          podeEditar: true,
          mode: 'create',
        },
      },
      showAjudaModalCidCiapsConsultas: false,
      showAjudaModalCidCiapsConsultaPuerperal: false,
      showAjudaModalCidCiapsConsultaProblemas: false,
    }
  },
  mounted() {},
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  computed: {
    exibirCopilot() {
      if (this.$store.state.infoMunicipio?.exibe_whatsapp == '1') {
        return true
      }
      return false
    },
    indexedItems() {
      if (this.cadastros !== undefined) {
        return this.cadastros.map((item, index) => {
          return {
            id: index,
            ...item,
          }
        })
      }
    },
    computedHeaders() {
      const base = [
        { text: 'Nome', align: 'start', filterable: true, value: 'no_cidadao' },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
          width: '150px',
        },
        { text: 'Mãe', align: 'start', filterable: false, value: 'no_mae' },
      ]
      const proxima = {
        text: 'Próxima',
        align: 'start',
        filterable: false,
        value: 'proxima_consulta',
      }
      const acompanhado = {
        text: 'Acompanhado',
        align: 'start',
        filterable: false,
        sortable: true,
        value: 'total_bp',
        width: '200px',
      }
      const parto = {
        text: 'Parto',
        align: 'start',
        filterable: false,
        value: 'parto',
      }
      const denominador = {
        text: 'DN',
        align: 'start',
        filterable: false,
        value: 'denominador',
      }

      // expand
      const expand = { text: '', value: 'data-table-expand' }

      if (this.tipo === 'puerperas') {
        return [...base, acompanhado, parto, denominador, expand]
      }

      return [...base, proxima, acompanhado, expand]
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {
      return `table-row-color-${item.rowColor}`
    },

    /**
     * Manipula o evento de expansão de um item da tabela.
     * @param {Object} item Contexto do item expandido
     */
    async onItemExpanded(item) {
      try {
        const rules = await rulesCopilot(item.item)
        Vue.set(item.item, 'rules', rules)
      } catch (error) {
        console.error('Erro ao obter as regras:', error)
      }
    },

    getDadosConsultaPerperio(item, data) {
      let items = JSON.parse(data)
      return items.filter((el) => {
        return item.parto && new Date(el.dt_atendimento) >= new Date(item.parto)
      })
    },

    getTextConsultas(item) {
      if (item.cons_pn == 0 && item.parto == 0 && item.aborto == 0) {
        return 'Profissional não registrou avaliação de pré-natal neste atendimento'
      }

      let text = []
      if (item.cons_pn == 1) {
        text.push('Pré-natal')
      }
      if (item.parto == 1) {
        text.push('Consulta Puerperal')
      }
      if (item.aborto == 1) {
        text.push('Aborto')
      }
      return text.join(', ')
    },

    getConsultasFiltradas(faiJson) {
      let lista = []
      try {
        lista = JSON.parse(faiJson) || []
      } catch {
        lista = []
      }
      if (this.modal.filter.consultas.selected === 'somente-aps') {
        return lista.filter((row) => Number(row?.ine_aps) === 1)
      }
      return lista
    },

    getConsultaIndexLista(lista, currentIndex) {
      let count = 0
      for (let i = 0; i <= currentIndex; i++) {
        if (lista[i]?.cons_pn == 1) count++
      }
      return count
    },

    getVisitasPuerperio(fvdt, parto, dpp) {
      let visitas = JSON.parse(fvdt)

      return visitas.filter((el) => {
        const visita = new Date(el.dt_visita)

        // Se tiver parto e a visita for >= parto
        if (parto && visita >= new Date(parto)) {
          return true
        }

        // Se tiver dpp e a visita for >= dpp
        if (dpp && visita >= new Date(dpp)) {
          return true
        }

        // Se nenhum dos casos, descarta
        return false
      })
    },

    getTextButtonBoaPratica(boaPratica, dpp, parto, key = '') {
      const hoje = new Date()
      const dataDpp = new Date(dpp)

      if (boaPratica > 0 && (hoje > dataDpp || parto != null)) {
        return `${boaPratica} pontos`
      }

      if (boaPratica > 0 && hoje < dataDpp && parto == null) {
        return 'Em dia'
      }

      if (boaPratica === 0 && hoje < dataDpp && parto == null) {
        if (
          key != '' &&
          (key == 'consultas' || key == 'afericao-pa' || key == 'peso-altura')
        ) {
          return 'Insuficiente'
        }
        return 'Atrasado(a)'
      }

      if (boaPratica === 0 && (hoje > dataDpp || parto != null)) {
        return `${boaPratica} pontos`
      }

      return ''
    },

    openModal(tipo, item) {
      this.modal.show = true
      this.modal.item = item
      this.modal.tipo = tipo
      switch (tipo) {
        case 'primeira-consulta':
          this.modal.title = 'Primeira consulta'
          this.modal.table.headers = [
            {
              label: 'CONSULTA',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'DUM',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'IG',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'DPP',
              icon: {
                show: false,
                text: '',
              },
            },
          ]
          break
        case 'consultas':
          this.modal.title = 'Consultas'
          this.modal.table.headers = [
            {
              label: 'N°',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Atendimento',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Tipo',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'CBO',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'CNES',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Motivo',
              icon: {
                show: true,
                text: 'Problema/Condição avaliada no atendimento',
              },
            },
          ]
          this.modal.filter.consultas.selected = 'somente-aps'
          break
        case 'afericao-pa':
          this.modal.title = 'Aferição PA'
          this.modal.table.headers = [
            {
              label: 'N°',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Data',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Sistólica',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Diastólica',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'CBO',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'MI',
              icon: {
                show: true,
                text: 'Modelo de Informação',
              },
            },
          ]
          break
        case 'peso-altura':
          this.modal.title = 'Peso e altura'
          this.modal.table.headers = [
            {
              label: 'N°',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Data',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Peso',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Altura',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'CBO',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'MI',
              icon: {
                show: true,
                text: 'Modelo de Informação',
              },
            },
          ]
          break
        case 'visitas':
          this.modal.title = 'Visitas'
          this.modal.table.headers = [
            {
              label: 'N°',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Data',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Motivo',
              icon: {
                show: true,
                text: 'Problema/Condição avaliada no atendimento',
              },
            },
            {
              label: 'Desfecho',
              icon: {
                show: false,
                text: '',
              },
            },
          ]
          break
        case 'vacinas':
          this.modal.title = 'Vacinas'
          this.modal.table.headers = []
          break
        case 'primeiro-trimestre':
          this.modal.title = 'Exames 1° trimestre'
          this.modal.table.headers = [
            {
              label: 'Data',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Procedimento',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Tipo',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Trimestre',
              icon: {
                show: true,
                text: 'Trimestre da gestação quando o procedimento foi realizado ou o exame foi avaliado',
              },
            },
          ]
          break
        case 'terceiro-trimestre':
          this.modal.title = 'Exames 3° trimestre'
          this.modal.table.headers = [
            {
              label: 'Data',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Procedimento',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Tipo',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Trimestre',
              icon: {
                show: true,
                text: 'Trimestre da gestação quando o procedimento foi realizado ou o exame foi avaliado',
              },
            },
          ]

          break
        case 'consulta-puerperio':
          this.modal.title = 'Consulta puerperal'
          this.modal.table.headers = [
            {
              label: 'Atendimento',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'CBO',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Motivo',
              icon: {
                show: true,
                text: 'Problema/Condição avaliada no atendimento',
              },
            },
          ]
          break
        case 'visita-puerperio':
          this.modal.title = 'Visita puerpério'
          this.modal.table.headers = [
            {
              label: 'Data',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Motivo',
              icon: {
                show: true,
                text: 'Problema/Condição avaliada no atendimento',
              },
            },
            {
              label: 'Desfecho',
              icon: {
                show: false,
                text: '',
              },
            },
          ]
          break
        case 'avaliacao-odontologica':
          this.modal.title = 'Avaliação odontológica'
          this.modal.table.headers = [
            {
              label: 'N°',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Data',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'CBO',
              icon: {
                show: false,
                text: '',
              },
            },
          ]
          break
        case 'problema':
          this.modal.title =
            'Lista de problemas ou condições ativos e resolvidos'
          this.modal.table.headers = [
            {
              label: 'Id',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Condição',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Início',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Fim',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Situação',
              icon: {
                show: false,
                text: '',
              },
            },
          ]
          break
        default:
          break
      }
    },

    resetFormVacina() {
      this.modalVacinas.form.dataAplicacao = null
      this.modalVacinas.form.lote = null
      this.modalVacinas.form.btn.loading = false
      this.modalVacinas.form.podeEditar = true
    },

    openModalVacina(item) {
      this.modalVacinas.form.podeEditar = true
      if (item.vacina != null) {
        this.modalVacinas.form.mode = 'edit'
        this.prefillFormVacina(item.vacina)
      } else {
        this.modalVacinas.form.mode = 'create'
      }
      this.modalVacinas.show = true
    },

    prefillFormVacina(item) {
      let doseParsed = JSON.parse(item)
      let dose = doseParsed[0]

      let orig = dose?.orig

      // só edita se orig == 3
      if (String(orig ?? '') !== '3') {
        this.modalVacinas.form.podeEditar = false
      }

      // lote
      if (dose?.lt != null && String(dose.lt).trim() !== '') {
        this.modalVacinas.form.lote = dose.lt
      } else {
        this.modalVacinas.form.lote = null
      }

      // data aplicação
      if (
        dose?.dt_aplicacao != null &&
        String(dose.dt_aplicacao).trim() !== ''
      ) {
        this.modalVacinas.form.dataAplicacao = this.formatDate(
          dose.dt_aplicacao
        )
      } else {
        this.modalVacinas.form.dataAplicacao = null
      }
    },

    async getCpfProfissional() {
      const res = await this.$api.post('/app/auth/usuario', {
        cod_ibge: this.$store.state.cod_ibge,
        id: this.$store.state.id,
      })

      const cpf = res?.data?.cpf
      if (!cpf) {
        return null
      }

      return cpf
    },

    async salvarVacina(item) {
      try {
        if (!this.modalVacinas.form.podeEditar) return

        const isValid = await this.$refs.observerModalVacinas.validate()

        if (!isValid) return

        this.modalVacinas.form.btn.loading = true

        const cpfProfissional = await this.getCpfProfissional()
        if (!cpfProfissional) return

        // Salvar vacina
        let response1 = await this.$api.post(
          '/app/gestantes-puerperas/vacina',
          {
            cod_ibge: this.$store.state.cod_ibge,
            dt_aplicacao: this.converterParaDataIso(
              this.modalVacinas.form.dataAplicacao
            ),
            cfcp: item.nu_cpf ?? item.nu_cns,
          }
        )
        if (!response1) return

        const payloadEfb = {
          co_ibge: this.$store.state.cod_ibge,
          cfcp: item.nu_cpf ?? item.nu_cns,
          nu_cns: item.nu_cns,
          nu_cpf: item.nu_cpf,
          cpf_profissional: cpfProfissional,
          id_imunobiologico: '57',
          id_dose_imunobiologico: '8',
          lote: this.modalVacinas.form.lote,
          dt_aplicacao: this.converterParaDataIso(
            this.modalVacinas.form.dataAplicacao
          ),
        }
        // Salvar efb vacina
        let response2 = await this.$api.post('/app/efb-vacina', payloadEfb)
        if (!response2) return

        if (response1.data.error === false && response2.data.error === false) {
          this.$toast.success('Vacina salva com sucesso!', 'Sucesso:', {
            position: 'topRight',
          })
        } else {
          this.$toast.error('Erro ao salvar vacina!', 'Erro:', {
            position: 'topRight',
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.modalVacinas.form.btn.loading = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.ultimo-acompanhamento {
  display: flex;
  align-items: center;
  // flex-direction: column;
  gap: 10px;
  span {
    background: #c4e8f6;
    color: #00aeef;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: 11px;
  }
}

.icon-copilot {
  img {
    background: #f7f7f7;
    color: #00aeef;
    border-radius: 10px;
    text-align: center;
    width: 40px;
    padding: 10px;
  }
}

.container-table-interna {
  height: 300px;
  overflow-y: scroll;
}

.table-boas-praticas {
  .table-boas-praticas-item {
    cursor: pointer;
    background-color: #fff;
    min-width: 120px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 10px;
    border: 1px solid #ccc;
    color: #fff;
    border-radius: 6px;
    font-size: 16px;
    text-align: center;
  }
}

.modal-gestantes-puerperas-body {
  .doses-list {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
    gap: 20px;
    margin: 20px 0;
    background-color: #f1f0f5;
    padding: 15px;
    h4 {
      font-size: 16px;
      margin-bottom: 0;
    }
    .doses-list-item {
      cursor: pointer;
      background-color: #fff;
      min-width: 120px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 10px;
      border: 1px solid #ccc;
      color: #000;
      border-radius: 6px;
      &.red {
        background: #ffb3b3 !important;
        // border-color: #990000 !important;
      }
      &.green {
        background: #b3ffb3;
        // border-color: #008000 !important;
      }
      &.white {
        background: #fff;
        // border-color: #000 !important;
      }
    }
  }
}
</style>
